// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2uBgf","notes":"Notes_notes__3RkBb","note":"Notes_note__3hn2l","markdown":"Notes_markdown__2rzVQ"};